angular.module('rightPaneModule')
  .controller("RosterLicenseSummaryController", ['$scope', '$state', 'configuration', function($scope, $state, $configuration) {
  }])
  .directive("rosterLicenseSummary", function() {
    return {
      restrict: "E",
      scope: {
        studentList: '='
      },
      templateUrl: '/resources/right-pane/partials/roster-license-summary.html',
      controller: 'RosterLicenseSummaryController',
      link: function(scope, $elem, $attr) {
         scope.$watch('studentList', function(newValue, oldValue) {
            if (angular.isArray(newValue)) {
                scope.totalStudentsCount = newValue.length;
                scope.activeStudentsCount = newValue.filter(function(obj) { return obj.activated; }).length;
                scope.inactiveStudentsCount = scope.totalStudentsCount - scope.activeStudentsCount;
            }
         });
      }
    };
  });
